export const COATING_DATA_PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 500, 1000] as const;

export const DEFAULT_COATING_DATA_PAGE_SIZE = 50;

export type CoatingDataPageSize = (typeof COATING_DATA_PAGE_SIZE_OPTIONS)[number];

export const normalizeCoatingDataPageSize = (value: number): CoatingDataPageSize => {
    if (COATING_DATA_PAGE_SIZE_OPTIONS.includes(value as CoatingDataPageSize)) {
        return value as CoatingDataPageSize;
    }
    return DEFAULT_COATING_DATA_PAGE_SIZE;
};
